import AppContainer from 'components/App/AppContainer';

import OrganizationsRoutes from './Organizations';
import PropertiesRoutes from './Properties';
import CropSeasonsRoutes from './CropSeasons';

import ProductionRoutes from './Production';

import InventoryRoutes from './Inventory';
import ProductsRoutes from './Products';
import ResourceRoutes from './Resources';
import YieldRoutes from './Yield';
import YieldV2Routes from './YieldV2';
import Integrations from './Integrations';
import ReportsRoutes from './Reports';

import ProfileRoutes from './Profile';
import WelcomeRoutes from './Welcome';

const appRoutes = [];

appRoutes.push(...OrganizationsRoutes);
appRoutes.push(...PropertiesRoutes);
appRoutes.push(...CropSeasonsRoutes);
appRoutes.push(...ProductionRoutes);
appRoutes.push(...ProductsRoutes);
appRoutes.push(...InventoryRoutes);
appRoutes.push(...ResourceRoutes);
appRoutes.push(...YieldV2Routes);
appRoutes.push(...YieldRoutes);
appRoutes.push(...Integrations);
appRoutes.push(...ReportsRoutes);

appRoutes.push(...ProfileRoutes);
appRoutes.push(...WelcomeRoutes);

const routes = [
  {
    id: 'appcontainer',
    key: 'appcontainer',
    path: '/app',
    secure: true,
    component: AppContainer,
    routes: appRoutes
  }
];

export default routes;
export { appRoutes };
